import Pusher from "pusher-js";
import { serverConfig } from "../config";

const PUSHER_KEY = "24bba5fe25c5374f7178";
const PUSHER_CLUSTER = "ap2";

let pusherInstance = null;

export function getPusherClient() {
  if (pusherInstance) return pusherInstance;

  const backendBase = serverConfig.serverURI.replace("/graphql", "");

  pusherInstance = new Pusher(PUSHER_KEY, {
    cluster: PUSHER_CLUSTER,
    channelAuthorization: {
      endpoint: `${backendBase}/pusher/auth`,
      transport: "ajax",
      headersProvider: () => {
        const token = localStorage.getItem("accessToken");
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
    },
  });

  return pusherInstance;
}

export function resetPusherClient() {
  if (pusherInstance) {
    pusherInstance.disconnect();
    pusherInstance = null;
  }
}
